/* eslint-disable react-hooks/exhaustive-deps */
import CloseIcon from 'saur_ui_library/src/Icons/Close';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import React, { useEffect, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { closeContract, contractService } from '../../utils/helpers/observer';
import { useDispatch } from 'react-redux';
import {
  SET_CONTRACT_CLOSE,
  SET_CONTRACT_CODE,
  SET_CONTRACT_ID,
  SET_CONTRACT_LABEL,
} from '../../redux/actionType';
import AutocompleteComponent from '../common/component/AutocompleteComponent';
import CpoError from '../common/CpoError';
import { LocalStorage } from '../../utils/localStorage';
import { getContractExtent } from '../../utils/helpers/map/mapHelper';
import {
  getCPO,
  getContractAdmin,
  getContractCollectivity,
} from './ContractPopupHelper';
import { loaderDataComponent } from '../../utils/helper';
import ResetStyleComponent from '../cssSaur/resetStyleComponent';

//admin profile = cpo and contract
//collectivity or edit profile = only contract

const ContractPopup = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cpoData, setCpoData] = useState<any[]>([]);
  const [contractData, setContractData] = useState([]);
  const [cpo, setCpo] = useState('');
  const sessionCode = window.sessionStorage.getItem('contractCode') || '';
  const [codeStatus, setCodeStatus] = useState<any>('200');
  const roles = LocalStorage.userRole.get();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setModalVisible(true);
    if (roles?.includes('collectivity-consult')) {
      getContractCollectivity(setLoading, setContractData, setCodeStatus);
    } else {
      getCPO(setLoading, setCpoData, setCodeStatus);
    }
    contractService.setContract(
      window.sessionStorage.getItem('contractCode') || '',
    );
  }, []);

  useEffect(() => {
    if (cpo !== '' && cpo !== undefined) {
      getContractAdmin(setLoading, setContractData, setCodeStatus, cpo);
    }
  }, [cpo]);
  
  const popupContent = () => (
    <Container
      className='contentContainer'
      style={{ width: 500, height: 'auto' }}
    >
      <CpoError statusCode={codeStatus} />
      <div
        style={{
          display: 'inline-flex',
          justifyContent: 'space-between',
        }}
      >
        <Word
          value='SELECTIONNER UN CONTRAT'
          textStyle='title'
          variant='span'
          automatedTestId='contract-title'
          className='contract-title'
        />
        {sessionCode !== '' ? (
          <span
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'end',
            }}
            onClick={() => {
              setModalVisible(false);
              closeContract.setStatus(false);
              dispatch({ type: SET_CONTRACT_CLOSE, payload: false });
            }}
            onKeyDown={() => {
              setModalVisible(false);
              closeContract.setStatus(false);
              dispatch({ type: SET_CONTRACT_CLOSE, payload: false });
            }}
          >
            <div style={{ height: '25px', width: '25px', cursor: 'pointer' }}>
              <CloseIcon />
            </div>
          </span>
        ) : null}
      </div>
      <br />
      {!roles?.includes('collectivity-consult') ? (
        <Container className='adminCpo'>
          <Word
            value='Cpo'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-cpo'
            className='fieldLabel'
          />
          <AutocompleteComponent
            id='dropdownCpo'
            Listoption={cpoData.map((c: any) => {
              return { name: c };
            })}
            onChangeValue={(event, option: any) => {
              if (option !== null) {
                setCpo(option.name.replace(' ', '%20').replace('&', '%26'));
              }
            }}
            placeholder='Choisir un Cpo'
          />
        </Container>
      ) : null}
      <br />
      <Container className='adminCpo'>
        <Word
          value='Contrat'
          textStyle='normalReg'
          variant='p'
          automatedTestId='id-contrat'
          className='fieldLabel'
        />
        <AutocompleteComponent
          id='dropdownContrat'
          Listoption={contractData.map((c: any) => {
            return {
              ...c,
              name: c.contractLabel
                ? c.contractLabel + ' - ' + c.contractCode
                : c.contractId + ' - ' + c.contractCode,
              id: c.contractCode,
            };
          })}
          onChangeValue={(event: any, option: any) => {
            // Capture previous contract before clearing sessionStorage
            const prevContractCode = window.sessionStorage.getItem('contractCode');
            setLoading(true);
            sessionStorage.clear();
            dispatch({
              type: SET_CONTRACT_ID,
              payload: option.contractId,
            });
            dispatch({
              type: SET_CONTRACT_CODE,
              payload: option.contractCode,
            });
            dispatch({
              type: SET_CONTRACT_LABEL,
              payload: option.contractLabel,
            });
            // get prevCOntractCode before getting the new contractCode
            window.sessionStorage.setItem(
              'prevContractCode',
              window.sessionStorage.getItem('contractCode')!
            );
            window.sessionStorage.setItem('contractCode', option.contractCode);
            window.sessionStorage.setItem('contractId', option.contractId);
            window.sessionStorage.setItem(
              'contractLabel',
              option.contractLabel
            );
            window.sessionStorage.setItem('codesEcp', 'null');
            window.localStorage.setItem('type', 'do');
            // notify already-mounted views (e.g. ViewComponent) of the new contract
            // in case navigation below is a no-op (same route, no remount)
            contractService.setContract(option.contractCode);
            // get extent of contract
            getContractExtent(option.contractCode).then((extent) => {
              window.sessionStorage.setItem(
                'contractExtent',
                JSON.stringify(extent)
              );
              // Only reload if switching to a different contract (not on initial selection or same contract)
              if (prevContractCode && prevContractCode !== option.contractCode) {
                // Contract change - reload page to reset filters
                window.location.reload();
              } else {
                // First selection or same contract - close modal and navigate normally
                setModalVisible(false);
                closeContract.setStatus(false);
                dispatch({ type: SET_CONTRACT_CLOSE, payload: false });
                // real path change so the module view mounts fresh with the contract already set
                navigate('/DO');
              }
              setLoading(false);
            });
          }}
          placeholder='Choisir un contrat'
        />
      </Container>
      <br />
      {loaderDataComponent(loading)}
    </Container>
  );

  return (
    <Container className='sds-reset-style contractContainer'>
      <ResetStyleComponent />
      <Styles />
      <ModalFlexible
        className='contract-modal'
        showHeader
        title=''
        toggleModal={() => {
          setModalVisible(!modalVisible);
        }}
        visible={modalVisible}
        desktopContent={popupContent}
      />
    </Container>
  );
};
const Styles = createGlobalStyle`
.contractContainer{
  .contract-modal{
    .modal-flex-desktop-header{
    display:none !important;
  }
  }
  .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position {
    display: flex;
    height: fit-content;
  }
  
.contract-title, .fieldLabel,.elementList{
  text-align: start;
}
.contract-cancel{
  text-decoration:underline;
}
.cancel{
  margin-left: auto;
  margin-right: auto;
}
.adminCpo{
  .dropdown-list{
    text-align: start;
    z-index:50;
  }
}
.contentContainer{
  margin-left: auto;
  margin-right: auto;  
}
.dropdown-list{
  z-index:30;
}
.loaderContainer{
  margin-top:0px;
}
  }
`;
export default ContractPopup;
